import { StoreState } from "./index";
import defaultsDeep from "lodash/defaultsDeep";
import some from "lodash/some";
import { store } from "../../store";
import { StoreState as RootState } from "../index";

interface PreviousValues {
  merchant: StoreState["merchant"] | null;
  config: StoreState["config"] | null;
  loyalty: RootState["loyalty"] | null;
  rewards: {
    ledgerHead: RootState["reward"]["ledgerHead"];
    shopifyActiveDiscounts: RootState["reward"]["shopifyActiveDiscounts"];
    shopifyActiveGiftCards: RootState["reward"]["shopifyActiveGiftCards"];
    reward: RootState["exchange"]["exchange"]["selectedExchange"];
    ledger: {
      newBalance: RootState["exchange"]["exchange"]["newBalance"];
    };
  } | null;
  memberTier: RootState["memberTier"] | null;
  userInput: StoreState["userInput"] | null;
}

const previousValues: PreviousValues = {
  merchant: null,
  config: null,
  rewards: null,
  userInput: null,
  loyalty: null,
  memberTier: null,
};

let dataState: any = null;

export const getWidgetData = (state: StoreState): StoreState => {
  const rootState = store.getState() as RootState;
  const rewards = {
    ledgerHead: rootState.reward.ledgerHead,
    shopifyActiveDiscounts: rootState.reward.shopifyActiveDiscounts,
    shopifyActiveGiftCards: rootState.reward.shopifyActiveGiftCards,
    reward: rootState.exchange.exchange.selectedExchange,
    ledger: {
      newBalance: rootState.exchange.exchange.newBalance,
    },
  };
  const loyalty = {
    ledgerContext: rootState.loyalty.ledgerContext,
    pdpPointsTotal: rootState.loyalty.pdpPointsTotal,
  };
  const memberTier = rootState.memberTier;

  const changed = some([
    previousValues.merchant !== state.merchant,
    previousValues.config !== state.config,
    previousValues.userInput !== state.userInput,
    previousValues.rewards !== rewards,
    previousValues.loyalty !== loyalty,
    previousValues.memberTier !== memberTier,
  ]);

  if (changed) {
    previousValues.merchant = state.merchant;
    previousValues.config = state.config;
    previousValues.userInput = state.userInput;
    previousValues.rewards = rewards;
    previousValues.memberTier = memberTier;
    dataState = defaultsDeep(
      {},
      state.userInput,
      state.merchant,
      state.config,
      rewards,
      loyalty,
      memberTier
    );
  }

  return dataState;
};
